// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { MoreHorizontal, Power, PowerOff, Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface PiiMarkerActionsMenuProps {
  isActive: boolean;
  /** A cleared mask has no regions left, so there is nothing to activate. */
  canActivate: boolean;
  onToggleActive: () => void;
  onDelete: () => void;
}

export function PiiMarkerActionsMenu({ isActive, canActivate, onToggleActive, onDelete }: PiiMarkerActionsMenuProps) {
  const { t } = useTranslation("back-office");
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="h-8 w-8">
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" sideOffset={-32} className="dropdown-overlap">
        {isActive ? (
          <DropdownMenuItem onSelect={onToggleActive} className="text-destructive focus:text-destructive">
            <PowerOff className="h-4 w-4 text-destructive" />
            {t("piiMarker.actions.deactivate")}
          </DropdownMenuItem>
        ) : (
          <DropdownMenuItem onSelect={onToggleActive} disabled={!canActivate}>
            <Power className="h-4 w-4" />
            {t("piiMarker.actions.activate")}
          </DropdownMenuItem>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={onDelete} className="text-destructive focus:text-destructive">
          <Trash2 className="h-4 w-4 text-destructive" />
          {t("piiMarker.actions.delete")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
